<ion-header class="ion-no-border">
  <ion-toolbar class="transparent_toolbar">
    <ion-buttons slot="start">
      <ion-button (click)="modalDismiss()">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="form__content highlight-gradient">
  <form [formGroup]="form" *ngIf="form" class="form">
    <ion-grid [fixed]="true">
      <ion-row>
        <ion-col size="12">
          <h3 class="form__title">Подтвердить код</h3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <p class="form__text">
            На телефон {{phone}}<br> отправлено сообщение.<br> Введите полученный код<br> на этом экране
          </p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <div class="input-form-group">
            <ion-label class="input-label">Код</ion-label>
            <ion-input class="input" formControlName="code" (keyup)="$event.key === 'Enter' && send()"></ion-input>
            <ion-note class="input-error" *ngIf="form.get('code')?.touched && form.get('code')?.invalid"
              slot="error">Введите код</ion-note>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <div class="form__buttons">
            <ion-button shape="round" class="button button_round button_light" (click)="send()"
              [disabled]="isSend">Продолжить</ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>

</ion-content>
